import React from 'react';
import { LayersIcon } from 'lucide-react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-blue-100 bg-blue-50 py-14 md:py-16" data-id="element-52" data-mp="3gg1025qei1yp">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-53" data-mp="32ovwwtntqrjm">
        <p className="inline-flex items-center gap-2 font-display text-base font-extrabold uppercase tracking-[0.1em] text-blue-600 md:text-lg md:tracking-[0.14em]" data-id="element-54" data-mp="36oxzd51dvozy">
          <LayersIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-55" data-mp="3ucxsgbm63rhp" />
          50 Mapas Visuales de Electroterapia
        </p>

        <p className="mx-auto mt-5 max-w-xl text-blue-900/75" data-id="element-56" data-mp="3levgx24t5gg6">
          Material digital | Acceso inmediato | Garantía de satisfacción 7 días
        </p>

        <nav aria-label="Enlaces legales" data-id="element-57" data-mp="3qblyjtw9gk3p">
          <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-blue-900/75" data-id="element-58" data-mp="29ynnprb9nhh6">
            {footerLinks.map(link => <li key={link.label} data-id="element-59" data-mp="2ezl5i2sd69i5">
                <a href={link.href} className="rounded transition-colors duration-150 ease-calm hover:text-blue-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-300" data-id="element-60" data-mp="3l9adfilcf44f">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <p className="mt-10 border-t border-blue-100 pt-6 text-sm text-blue-900/60" data-id="element-61" data-mp="3q7bvc0718xeb">
          © 2026 50 Mapas Visuales de Electroterapia. Todos los derechos reservados.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-xs leading-relaxed text-blue-900/60" data-id="element-62" data-mp="335u5kj2dpi2">
          Material educativo y de consulta visual dirigido a estudiantes y profesionales. No sustituye
          la evaluación clínica individual, la formación profesional, las instrucciones del fabricante
          ni los protocolos institucionales.
        </p>
      </div>
    </footer>;
}